import React, { useState, useContext, useEffect } from 'react';
import { useHistory, Redirect, useLocation } from 'react-router-dom';
import { format } from 'date-fns';
import { InvoicesAppContext } from '../../context';
import { RoutePath } from '../../constants';
import { getToken, doFormatDate } from '../../../../helpers';
import { PaymentModal } from '../PaymentModal';
import { PackagePaymentView } from './PackagePaymentView';
import { ErrorHandler } from '../ErrorHandler';
import { useAxios } from '../../../../hooks/useAxios';
import { createInvoicePath, accountsBalancesPath } from '../../routes';
import { TimeFormat } from '../../../../types';

export const PackagePayment = () => {
  const {
    setIsModalVisible,
    isMobileSite,
    hasErrors,
    setHasErrors,
    setSelectedInvoice,
    selectedInvoice,
    setBalanceData,
    balanceValueData
  } = useContext(InvoicesAppContext);

  const history = useHistory();
  const location = useLocation();
  const [option, setOption] = useState(30);
  const [isPackagePaymentBlocked, blockPackagePaymentBtn] = useState(false);

  const name = history.location?.state?.name;
  const tariffCount = history.location?.state?.paid_ads_count;
  const price = history.location?.state?.price;
  const promotions = history.location?.state?.promotions;
  const wallet_amount = history.location?.state?.wallet_amount;
  const expired = history.location?.state?.expired;

  const expireDateOption = expired && doFormatDate({ date: expired, format: TimeFormat.date });
  const today = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Baku' }));
  const todayDateOption = format(today, TimeFormat.date);

  const [date, setDate] = useState(todayDateOption);
  const [invoicePrice, setPrice] = useState(price);
  const [walletAmount, setWalletAmount] = useState(wallet_amount);
  const [adsCount, setAdsCount] = useState(tariffCount);

  const multiplyPackageData = (counter = 1) => {
    setAdsCount(tariffCount * counter);
    setWalletAmount(wallet_amount * counter);
    setPrice(price * counter);
  };

  const { callRequest: getBalanceValue } = useAxios({
    method: 'get',
    url: accountsBalancesPath,
    isInitialCall: true,
    onSuccess: data => setBalanceData(data?.cash),
    onError: () => setHasErrors(true)
  });

  if (!history.location?.state) {
    return <Redirect to={{ pathname: RoutePath.packages }} />;
  }

  if (!isMobileSite && location.pathname === RoutePath.packages_payment) {
    document.querySelector('.profile-navbar').classList.add('hidden');
  }

  window.addEventListener('popstate', () => {
    if (!isMobileSite && location.pathname === RoutePath.packages_payment) {
      document.querySelector('.profile-navbar').classList.remove('hidden');
    }
    setIsModalVisible(false);
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!balanceValueData) return getBalanceValue();
  }, []);

  const dateOnRequest = date === expireDateOption
    ? 'max_expires_date'
    : 'today';

  const { callRequest: createInvoice } = useAxios({
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'X-Csrf-Token': getToken()
    },
    body: JSON.stringify({
      starts_at_constant: dateOnRequest,
      period: option,
      tariff_plan_title: name
    }),
    url: createInvoicePath,
    onSuccess: data => {
      setSelectedInvoice(data);
    },
    onError: () => setHasErrors(true)
  });

  const handlePaymentClick = () => {
    blockPackagePaymentBtn(true);
    createInvoice();
  };

  useEffect(() => {
    if (selectedInvoice?.services?.tariff_plan_title === name
      && isPackagePaymentBlocked) {
      setIsModalVisible(true);
      blockPackagePaymentBtn(false);
    }
  }, [selectedInvoice]);

  if (hasErrors) return <ErrorHandler />;

  return (
    <>
      <div className="package-payment">
        <PackagePaymentView {
          ...{
            option,
            setOption,
            name,
            promotions,
            expired,
            expireDateOption,
            todayDateOption,
            date,
            setDate,
            invoicePrice,
            multiplyPackageData,
            walletAmount,
            adsCount,
            isPackagePaymentBlocked,
            handlePaymentClick
          }
        }
        />
      </div>
      <PaymentModal />
    </>
  );
};
